import { GridCellVisibilityCheckboxForwardRef } from "@components/DataGrid/components/columnVisibility/GridCellVisibilityCheckboxRenderer";
import { GridHeaderVisibilityCheckbox } from "@components/DataGrid/components/columnVisibility/GridHeaderVisibilityCheckbox";
import { visibilityIdsLookupSelector } from "@components/DataGrid/hooks/features/rowVisibilitySelection/gridRowVisibilitySelector";
import { GRID_BOOLEAN_COL_DEF, GridColDef } from "@mui/x-data-grid-premium";

export const GRID_CHECKBOX_VISIBILITY_SELECTION_FIELD = "__visibility__"; // TODO: move to reusable location

export const GRID_VISIBILITY_COL_DEF: GridColDef = {
  ...GRID_BOOLEAN_COL_DEF,
  type: "custom",
  field: GRID_CHECKBOX_VISIBILITY_SELECTION_FIELD,
  renderHeader: (params) => <GridHeaderVisibilityCheckbox {...params} />,
  width: 50,
  resizable: false,
  sortable: false,
  filterable: false,
  aggregable: false,
  disableColumnMenu: true,
  disableReorder: true,
  disableExport: true,
  getApplyQuickFilterFn: undefined,
  display: "flex",
  valueGetter: (_value: any, row: any, _column: any, apiRef: any) => {
    const currentLookup = visibilityIdsLookupSelector(apiRef);
    const rowId = apiRef.current.getRowId(row);
    return currentLookup[rowId] !== undefined;
  },
  renderCell: (params) => <GridCellVisibilityCheckboxForwardRef {...params} />,
};
